export default __webpack_public_path__ + "e7c5018141e856e1d4835d9c549a05b2.png";